import { render } from "./ContactColumnManageDrawer.vue?vue&type=template&id=002dddc3&scoped=true"
import script from "./ContactColumnManageDrawer.vue?vue&type=script&lang=js"
export * from "./ContactColumnManageDrawer.vue?vue&type=script&lang=js"

import "./ContactColumnManageDrawer.vue?vue&type=style&index=0&id=002dddc3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002dddc3"]])

export default __exports__